module.exports = __webpack_public_path__ + "img/Untitled-1.162a6ae4.png";